export const USE_TOOLTIP = process.env.REACT_APP_HIDE_TOOLTIP !== 'true';